import {memo} from 'react'

/** Single portal target ID for the docked side panel content region */
export const DOCKED_SIDE_PANEL_CONTENT_ID = 'docked-side-panel-content'

/**
 * Shell for the docked side panel. Renders a portal target that panel components
 * (Comments, Alerts, Overview) render into via `createPortal`. Each panel renders
 * a `<Panel panelName="...">` which owns its own heading, close button, and layout.
 *
 * For panels that should be rendered directly (not via portal), add a match on
 * `panelName` here and render the Panel inline.
 */
export const DockedSidePanelContent = memo(function DockedSidePanelContent() {
  return <div id={DOCKED_SIDE_PANEL_CONTENT_ID} className="height-full" />
})
